<template>
  <section class="holidayTypeAccommodations defaultSectionMargins">
    <div class="container">
      <h2 v-text="data.title" />
  
      <div class="holidayTypeAccommodations__List">
        <SimilarAccommodationsSlider :locations="locations" :flickityOptions="flickityOptions" />
      </div>
    </div>
  </section>
</template>

<script setup>
  const { accommodationsData } = useSetup();
  const dataLayerList = useState('dataLayerList');
  const props = defineProps({
    data: {}
  });

  const flickityOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
  };

  const locations = computed(() => {
    return props.data.items.map(item => accommodationsData.value[item.accommodation] || {});
  });

  let allItems = JSON.parse(JSON.stringify(locations.value));
  let ecommerceItems = [];
  ecommerceItems = allItems.map((accommodation, index) => {
    return {
      'item_id': accommodation.id,
      'item_name': accommodation.name,
      'item_category': accommodation.kind === 'CAMP' ? 'Campsites' : 'Hotels and resorts',
      'item_category2': accommodation.place?.name,
      'item_brand': accommodation.brand?.name,
      'item_list_name': props.data.title,
      'item_list_id': 'Holiday types',
      'index': index + 1,
    }
  });

  onMounted(() => {
    dataLayerList.value = ecommerceItems;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      'event': 'view_item_list',
      'ecommerce': {
        'items': ecommerceItems,
      },
    });
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_holidayTypeAccommodations.scss');
</style>